
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-list",
      function () {
        return require("private-next-pages/why-list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-list"])
      });
    }
  